import { set } from 'nprogress'
import { createStore } from 'vuex'
import { getHomeConfig } from '@/api/home/index.js'

export default createStore({
    state: {
        webDate: null,
        webConfig: null,
    },
    mutations: {
        setWebDate(state, data) {
            state.webDate = data
        },
        setWebConfig(state, data) {
            state.webConfig = data
        }
    },
    actions: {
        getHomeConfigData({ commit }) {
            getHomeConfig({ type: 1 }).then(res => {
                if (res.code == 0) {
                    if (res.data) {
                        commit('setWebDate', JSON.parse(res.data.context))
                    }
                }
            })
            getHomeConfig({ type: 2 }).then(res => {
                if (res.code == 0) {
                    if (res.data) {
                        commit('setWebConfig', JSON.parse(res.data.context))
                    }
                }
            })
        }
    }
})
